import React from 'react'
import FormHeader from '../shared/FormHeader/FormHeader'
import { BackButton, baseUrl } from './Examples'

const ExampleFormHeader = (): JSX.Element => {
    return (
        <div style={{ top: 100, position: 'relative' }}>
            <BackButton href={baseUrl} />

            <div>
                <h2>Component FormHeader, exemplo 1:</h2>
                <FormHeader
                    asset={{
                        id: 123,
                        name: 'NS-123',
                        perspectiveId: 1,
                        dashboardsIds: new Set(['1', '2', '3'])
                    }}
                    icon="fas fa-bell"
                    title="Example"
                    subtitle="Some subtitle"
                    legends={[
                        {
                            icon: 'far fa-circle',
                            color: 'blue',
                            value: 'default'
                        },
                        {
                            icon: 'far fa-circle',
                            color: 'orange',
                            value: 'standard'
                        }
                    ]}
                    backgroundImg="https://www.w3schools.com/w3images/mountains.jpg"
                    enableImg={true}
                    enableOpt={true}
                    titleIcon={{
                        icon: 'far fa-map-marked-alt',
                        color: 'blue'
                    }}
                    dividerSize={20}
                />
            </div>
        </div>
    )
}

export default ExampleFormHeader
